import * as React from 'react';
import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

type Props = {
    items: any,
    controller: string,
    modal?: React.ReactNode,
    modaltitle?: string,
    modalwidth?: string,
    state?: any
}

export default (props: Props) => {
    return (
        <>
            <DataList items={props.items} modaltitle={props.modaltitle} modalwidth={props.modalwidth} modalController={props.controller} modal={props.modal} state={props.state}>
                <DataColumn kid='columnE' name='' fieldName='delete' minWidth={10} maxWidth={10} type='delete' />
                <DataColumn kid='column1' name='Tipo Plafond' fieldName='leap_InsuredPlafondTypeID' minWidth={150} maxWidth={200} align='left' />
                <DataColumn kid='column2' name='Data Inizio Validita' fieldName='startDate' minWidth={150} maxWidth={200} align='center' />
                <DataColumn kid='column3' name='Data Fine Validita' fieldName='endDate' minWidth={150} maxWidth={200} align='center' />
                <DataColumn kid='column4' name='Plafond' fieldName='plafondID' minWidth={200} align='left' />
                <DataColumn kid='columnF' name='' fieldName='edit' minWidth={10} maxWidth={10} type='edit' />
            </DataList>
        </>
    );
}
